export default __webpack_public_path__ + "_/shared_modules/base-layout/img/checked-b0cb1a982623eabcf7acf54a8ba5f704.png";